<template>
  <div
    class="label-checkbox-field"
    :class="[
      stacked ? 'label-checkbox-field--stacked' : 'label-checkbox-field--glass',
      {
        'label-checkbox-field--checked': modelValue,
        'label-checkbox-field--flex': flex,
        'label-checkbox-field--disabled': disabled,
        'label-checkbox-field--focused': isFocused,
      },
      customClass,
    ]"
    role="checkbox"
    :aria-checked="modelValue ? 'true' : 'false'"
    :aria-labelledby="labelId"
    tabindex="0"
    @click="toggle"
    @keydown.enter.prevent="toggle"
    @keydown.space.prevent="toggle"
    @focusin="isFocused = true"
    @focusout="isFocused = false"
  >
    <template v-if="stacked">
      <span :id="labelId" class="label-checkbox-field__label">{{ label }}</span>
      <div class="label-checkbox-field__control">
        <input
          :id="inputId"
          type="checkbox"
          class="label-checkbox-field__input"
          :checked="modelValue"
          :disabled="disabled"
          :aria-labelledby="labelId"
          @click.stop
          @change="onChange"
          @focus="isFocused = true"
          @blur="isFocused = false"
        />
      </div>
    </template>
    <template v-else>
      <input
        :id="inputId"
        type="checkbox"
        class="label-checkbox-field__input"
        :checked="modelValue"
        :disabled="disabled"
        :aria-labelledby="labelId"
        @click.stop
        @change="onChange"
        @focus="isFocused = true"
        @blur="isFocused = false"
      />
      <span :id="labelId" class="label-checkbox-field__label">{{ label }}</span>
    </template>
  </div>
</template>

<script>
export default {
  name: 'LabelCheckboxField',
  props: {
    label: {
      type: String,
      default: 'Active',
    },
    inputId: {
      type: String,
      required: true,
    },
    modelValue: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    flex: {
      type: Boolean,
      default: false,
    },
    stacked: {
      type: Boolean,
      default: false,
    },
    customClass: {
      type: [String, Array, Object],
      default: '',
    },
  },
  emits: ['update:modelValue', 'change'],
  data() {
    return {
      isFocused: false,
    };
  },
  computed: {
    labelId() {
      return `${this.inputId}-label`;
    },
  },
  methods: {
    toggle() {
      if (this.disabled) return;
      const next = !this.modelValue;
      this.$emit('update:modelValue', next);
      this.$emit('change', next);
    },
    onChange(event) {
      const checked = event.target.checked;
      this.$emit('update:modelValue', checked);
      this.$emit('change', checked);
    },
  },
};
</script>

<style src="../styles/LabelCheckboxField.css"></style>
